import { ReactComponent as CloseIcon } from '@vkontakte/icons/src/svg/20/cancel_20.svg';
import { Spacing, Title } from '@vkontakte/vkui';
import { xray } from 'lib/xray';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { Tooltip}  from 'reactApp/ui/Tooltip/Tooltip';
import { tooltipPlacements } from 'reactApp/ui/Tooltip/Tooltip.constants';

import styles from './QuotaCleanerYearFilterPromo.css';

interface QuotaCleanerYearFilterPromoProps {
    target: Element;
    storeValue: number | null;
    onHide: () => void;
}

export const QuotaCleanerYearFilterPromo: FC<QuotaCleanerYearFilterPromoProps> = ({ target, storeValue, onHide }) => {
    const [isClosed, setIsClosed] = useState(!!storeValue);
    const [isShown, setIsShown] = useState(false);

    const canShow = useMemo(() => target && !isClosed, [target, isClosed]);

    const handleHide = useCallback(() => {
        setIsClosed(true);
        onHide();
    }, [onHide, setIsClosed]);

    const onClose = useCallback(() => {
        handleHide();
        xray.send('quota-cln-year-flt-pr-close');
    }, [handleHide]);

    const onTargetClick = useCallback(() => {
        handleHide();
        xray.send('quota-cln-year-flt-pr-submit');
    }, [handleHide]);

    useEffect(() => {
        if (target) {
            target.addEventListener('click', onTargetClick);
            return () => target.removeEventListener('click', onTargetClick);
        }
    }, [target]);

    useEffect(() => {
        if (canShow) {
            setIsShown(true);
        }
    }, [canShow, setIsShown]);

    useEffect(() => {
        if (isShown) {
            xray.send('quota-cln-year-flt-pr-show');
        }
    }, [isShown]);

    if (!canShow) {
        return null;
    }

    return (
        <Tooltip
            noPageOffset
            closeOnOutsideClick={false}
            minWidth={false}
            radius={20}
            target={target}
            placement={tooltipPlacements.BOTTOM_LEFT}
            qaId="quota-cleaner-year-filter-promo"
            theme="octavius"
            onClose={onClose}
        >
            <div className={styles.wrapper}>
                <CloseIcon className={styles.closeIcon} onClick={onClose} />
                <Title level="3" weight="2">
                    Фильтр по дате
                </Title>
                <Spacing size={4} />
                <div className={styles.text}>
                    Выберите нужный период, чтобы
                    <br />
                    посмотреть другие письма
                </div>
            </div>
        </Tooltip>
    );
};
